(function() {
	'use strict';

	angular.module('quantixApp').factory('InfrastructureProjectsService',InfrastructureProjectsService);

	InfrastructureProjectsService.$inject = [ '$resource','$http','$q', '$window' ];

	function InfrastructureProjectsService($resource,$http,$q, $window) {

		
		var _getSectorList = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getSectorList';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}	
		
				
		var _getModeOfAwardList = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getModeOfAwardList';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _getAwardingAuthorityList = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getAwardingAuthorityList';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _getProjectStatusList = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getProjectStatusList';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		
		var _getMinMaxProjectCost = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getMinMaxProjectCost';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		
		
		var _getUserSavedFilterList = function(sectorName) {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/getUserSavedFilterList';

			$http.get(url, {params: { sector: sectorName }}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		
		
		
		var _getZonalLocationDetailsdata = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getZonalStateLocationTreeList';
			$http.post(url).then(
						function(response) {
							deferred.resolve(response.data);
						}, function(response) {
							deferred.reject(response);
						});
			
			return deferred.promise;
		}
		
		
		var _getSelectedCompanyList = function(companyCodeList) {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/getSelectedCompanyList';
			$http.post(url,companyCodeList).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _getSelectedPromoterList = function(companyCodeList) {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/getSelectedPromoterList';
			$http.post(url,companyCodeList).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		
		
		var _deleteUserFilterById = function(id) {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/deleteUserFilterById';
			$http.post(url,id).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		
		var _getProjectDataMapForSelection = function(selectedFilterJson) {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/getProjectDataMapForSelection';
			$http.post(url,selectedFilterJson).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		var _viewRoadsData = function(selectedFilterJson) {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/viewRoadsData';
			$http.post(url,selectedFilterJson).then(function(response) {
				deferred.resolve(response);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		
		var _getProjectDataMapForEpc = function(selectedFilterJson) {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/getProjectDataMapForEpc';
			$http.post(url,selectedFilterJson).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		
		
		
	
		return {
			getSectorList : _getSectorList,			
			getModeOfAwardList : _getModeOfAwardList,
			getAwardingAuthorityList : _getAwardingAuthorityList,
			getProjectStatusList : _getProjectStatusList,
			getUserSavedFilterList : _getUserSavedFilterList,
			getZonalLocationDetailsdata : _getZonalLocationDetailsdata,
			getSelectedCompanyList : _getSelectedCompanyList,
			getSelectedPromoterList : _getSelectedPromoterList,
			deleteUserFilterById : _deleteUserFilterById,
			getProjectDataMapForSelection : _getProjectDataMapForSelection,
			viewRoadsData: _viewRoadsData,
			getMinMaxProjectCost : _getMinMaxProjectCost,
			getProjectDataMapForEpc:_getProjectDataMapForEpc
			
			
		};
	}
})();
